import { BundleChargingModel, ChargingModel } from '../types';

export const isBundleChargingModel = (
  chargingModel: ChargingModel | undefined,
): chargingModel is BundleChargingModel =>
  chargingModel?.type === 'deal' ||
  chargingModel?.type === 'freemium' ||
  chargingModel?.type === 'package' ||
  chargingModel?.type === 'promo';
